import React from 'react'
import './index.less'
import cdn from 'src/helper/cdn'
import { isRtl } from 'src/helper/tool'

import lang from '../lang'

export default class extends React.Component {
  state = {
    ruleStatus: false
  }

  constructor(props) {
    super(props)
    let { language } = this.props
  }

  // shouldComponentUpdate(nextProps) {
  //   console.log('shouldComponentUpdate')
  //   // return false
  // }

  componentDidMount() {
    // console.log('componentDidMount')
  }

  componentWillReceiveProps(e) {
    // console.log('componentWillReceiveProps')
  }


  hideRule = async (status) => {
    this.setState({
      ruleStatus: status
    })
  }

  render() {
    let { language, list, lang } = this.props
    return (
      <div>
        {this.state.ruleStatus && <div className="loading" onClick={this.hideRule.bind(this, false)}></div>}
        {this.state.ruleStatus && <div className={`popRule2 ${isRtl(language) && 'arlang'}`}>
          <div className="content">
            {/* <video src="/img/app/service/ex.mp4" controls="controls" autoplay loop muted preload>
            </video> */}
          </div>
        </div>}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/service/Video/index.js